import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";

// ACCESS PAGES
import { HomeComponent } from "./pages/home.component";

// ADMINISTRATION
import { AuditMasterComponent } from "./pages/administration/audit-master/audit-master.component";
import { SalesTeamShuffleComponent } from "./pages/administration/sales-team-shuffle/sales-team-shuffle.component";
import { UserManagementListComponent } from "./pages/administration/user-management/user-management-list/user-management-list.component";
import { UserManagementDetailComponent } from "./pages/administration/user-management/user-management-detail/user-management-detail.component";
import { UserTypeManagementListComponent } from "./pages/administration/user-type-management/user-type-management-list/user-type-management-list.component";
import { UserTypeManagementDetailComponent } from "./pages/administration/user-type-management/user-type-management-detail/user-type-management-detail.component";
import { UserRightsManagementComponent } from "./pages/administration/user-rights-management/user-rights-management.component";
import { KapsSettingsComponent } from "./pages/administration/kaps-settings/kaps-settings.component";

// CUSTOMER

import { CustomerSearchComponent } from "./pages/customer/customer-search/customer-search.component";
import { ProspectDetailComponent } from "./pages/customer/prospect/prospect-detail/prospect-detail.component";
import { ProspectListComponent } from "./pages/customer/prospect/prospect-list/prospect-list.component";
import { ClickDriveCustomerComponent } from "./pages/customer/click-drive-customer/click-drive-customer.component";
import { GenerateVoucherComponent } from "./pages/customer/click-drive-customer/generate-voucher/generate-voucher.component";
import { UpdateOrderComponent } from "./pages/customer/click-drive-customer/update-order/update-order.component";
import { PremiumCareMemberListComponent } from "./pages/customer/premium-care-member/premium-care-member-list/premium-care-member-list.component";
import { PremiumCareMemberDetailComponent } from "./pages/customer/premium-care-member/premium-care-member-detail/premium-care-member-detail.component";

//CUSTOMER REPORTS
import { PremiumCareMemberStatusComponent } from "./pages/customer-reports/premium-care-member-status/premium-care-member-status.component";

//RESERVATION
import { ReservationComponent } from "./pages/reservation/reservation/reservation.component";
import { ReservationDashboardComponent } from "./pages/reservation/reservation-dashboard/reservation-dashboard.component";
import { ReservationPriceListMasterDetailComponent } from "./pages/reservation/reservation-price-list-master/reservation-price-list-master-detail/reservation-price-list-master-detail.component";
import { ReservationPriceListMasterListComponent } from "./pages/reservation/reservation-price-list-master/reservation-price-list-master-list/reservation-price-list-master-list.component";

// VEHICLE
import { AccessoryDetailComponent } from "./pages/vehicle/accessory/accessory-detail/accessory-detail.component";
import { AccessoryListComponent } from "./pages/vehicle/accessory/accessory-list/accessory-list.component";
import { BookingComponent } from "./pages/vehicle/booking/booking.component";
import { ColoursByModelDetailComponent } from "./pages/vehicle/colours-by-model/colours-by-model-detail/colours-by-model-detail.component";
import { ColoursByModelListComponent } from "./pages/vehicle/colours-by-model/colours-by-model-list/colours-by-model-list.component";
import { DiscountComponent } from "./pages/vehicle/discount/discount.component";
import { InteriorColourDetailComponent } from "./pages/vehicle/interior-colour/interior-colour-detail/interior-colour-detail.component";
import { InteriorColourListComponent } from "./pages/vehicle/interior-colour/interior-colour-list/interior-colour-list.component";
import { MasterColourDetailComponent } from "./pages/vehicle/master-colour/master-colour-detail/master-colour-detail.component";
import { MasterColourListComponent } from "./pages/vehicle/master-colour/master-colour-list/master-colour-list.component";
import { ModelAndSpecificationDetailComponent } from "./pages/vehicle/model-and-specification/model-and-specification-detail/model-and-specification-detail.component";
import { ModelAndSpecificationListComponent } from "./pages/vehicle/model-and-specification/model-and-specification-list/model-and-specification-list.component";
import { PromotionDetailComponent } from "./pages/vehicle/promotion/promotion-detail/promotion-detail.component";
import { PromotionListComponent } from "./pages/vehicle/promotion/promotion-list/promotion-list.component";
import { ReinstateBookingComponent } from "./pages/vehicle/reinstate-booking/reinstate-booking.component";
import { VehicleSelectionComponent } from "./pages/vehicle/vehicle-selection/vehicle-selection.component";
import { VehicleStockAvailabilityComponent } from "./pages/vehicle/vehicle-stock-availability/vehicle-stock-availability.component";

// AUTOPAC
import { AccountAdjustmentComponent } from "./pages/autopac/account-adjustment/account-adjustment.component";
import { AccountCodeCreationComponent } from "./pages/autopac/account-code-creation/account-code-creation.component";
import { AmendChequePurposeComponent } from "./pages/autopac/amend-cheque-purpose/amend-cheque-purpose.component";
import { CarAllocationComponent } from "./pages/autopac/car-allocation/car-allocation.component";
import { CardsDepositListingComponent } from "./pages/autopac/cards-deposit-listing/cards-deposit-listing.component";
import { CarRegistrationComponent } from "./pages/autopac/car-registration/car-registration.component";
import { CashDepositListingComponent } from "./pages/autopac/cash-deposit-listing/cash-deposit-listing.component";
import { ChequeDepositListingComponent } from "./pages/autopac/cheque-deposit-listing/cheque-deposit-listing.component";
import { ChequeEnquiryComponent } from "./pages/autopac/cheque-enquiry/cheque-enquiry.component";
import { ChequeIssueComponent } from "./pages/autopac/cheque-issue/cheque-issue.component";
import { CoeAllocationComponent } from "./pages/autopac/coe-allocation/coe-allocation.component";
import { CoeBiddingPreparationComponent } from "./pages/autopac/coe-bidding-preparation/coe-bidding-preparation.component";
import { CoeBiddingResultsComponent } from "./pages/autopac/coe-bidding-results/coe-bidding-results.component";
import { CoeBidStaffComponent } from "./pages/autopac/coe-bid-staff/coe-bid-staff.component";
import { ContractManagementComponent } from "./pages/autopac/contract-management/contract-management.component";
import { CustomerEnquiryComponent } from "./pages/autopac/customer-enquiry/customer-enquiry.component";
import { DutyPulloutComponent } from "./pages/autopac/duty-pullout/duty-pullout.component";
import { DutyPulloutTaxiComponent } from "./pages/autopac/duty-pullout-taxi/duty-pullout-taxi.component";
import { ExportToHMCComponent } from "./pages/autopac/export-to-hmc/export-to-hmc.component";
import { ExportToHmcNewComponent } from "./pages/autopac/export-to-hmc-new/export-to-hmc-new.component";
import { FinanceVehicleReceiptComponent } from "./pages/autopac/finance-vehicle-receipt/finance-vehicle-receipt.component";
import { GeneralEnquiryComponent } from "./pages/autopac/general-enquiry/general-enquiry.component";
import { GstCalculationComponent } from "./pages/autopac/gst-calculation/gst-calculation.component";
import { InvoiceComponent } from "./pages/autopac/invoice/invoice.component";
import { MonthlyCommissionComponent } from "./pages/autopac/monthly-commission/monthly-commission.component";
import { OpenCategoryCoeDepositoryComponent } from "./pages/autopac/open-category-coe-depository/open-category-coe-depository.component";
import { ParfTransferDateComponent } from "./pages/autopac/parf-transfer-date/parf-transfer-date.component";
import { PaymentStatusReadOnlyComponent } from "./pages/autopac/payment-status-read-only/payment-status-read-only.component";
import { TaxiRegistrationComponent } from "./pages/autopac/taxi-registration/taxi-registration.component";
import { UpdateVehicleRateComponent } from "./pages/autopac/update-vehicle-rate/update-vehicle-rate.component";
import { EtaDateUpdationComponent } from "./pages/autopac/eta-date-updation/eta-date-updation.component";
import { OpenCategoryCoeTransferComponent } from "./pages/autopac/open-category-coe-transfer/open-category-coe-transfer.component";
import { LocationMasterListComponent } from "./pages/autopac/location-master/location-master-list/location-master-list.component";
import { LocationMasterDetailComponent } from "./pages/autopac/location-master/location-master-detail/location-master-detail.component";
import { GiroPaymentComponent } from "./pages/autopac/giro-payment/giro-payment.component";
import { PaymentListComponent } from "./pages/autopac/payment-list/payment-list.component";
import { PaymentStatusComponent } from "./pages/autopac/payment-status/payment-status.component";
import { FobInvoicePriceComponent } from "./pages/autopac/fob-invoice-price/fob-invoice-price.component";
import { SalesmanReceiptComponent } from "./pages/autopac/salesman-receipt/salesman-receipt.component";
import { ServiceEnquiryComponent } from "./pages/autopac/service-enquiry/service-enquiry.component";
import { StockHoldReleaseComponent } from "./pages/autopac/stock-hold-release/stock-hold-release.component";
import { ReceiptComponent } from "./pages/autopac/receipt/receipt.component";

// AUTOPAC REPORTS
import { AccessoryReportComponent } from "./pages/autopac-reports/accessory-report/accessory-report.component";
import { COEBidsDetailsByDateReportComponent } from "./pages/autopac-reports/coe-bids-details-by-date-report/coe-bids-details-by-date-report.component";
import { COEBidsDetailsReportComponent } from "./pages/autopac-reports/coe-bids-detail-report/coe-bids-detail-report.component";

//SALES
import { HirePurchaseListComponent } from "./pages/sales/hire-purchase/hire-purchase-list/hire-purchase-list.component";
import { HirePurchaseDetailComponent } from "./pages/sales/hire-purchase/hire-purchase-detail/hire-purchase-detail.component";
import { InsuranceListComponent } from "./pages/sales/insurance/insurance-list/insurance-list.component";
import { InsuranceDetailComponent } from "./pages/sales/insurance/insurance-detail/insurance-detail.component";
import { LoanStatusReportComponent } from "./pages/sales/loan-status-report/loan-status-report.component";
import { ControlParametersComponent } from "./pages/sales/control-parameters/control-parameters.component";
import { InventoryVehicleComponent } from "./pages/sales/inventory-vehicle/inventory-vehicle.component";
import { ShipmentMasterComponent } from "./pages/sales/shipment-master/shipment-master/shipment-master.component";
import { PriceListTemplateListComponent } from "./pages/sales/price-list-template/price-list-template-list/price-list-template-list.component";
import { PriceListTemplateDetailComponent } from "./pages/sales/price-list-template/price-list-template-detail/price-list-template-detail.component";
import { PriceListTemplateReportComponent } from "./pages/sales/price-list-template-report/price-list-template-report.component";
import { PriceListMasterListComponent } from "./pages/sales/price-list-master/price-list-master-list/price-list-master-list.component";
import { PriceListMasterDetailComponent } from "./pages/sales/price-list-master/price-list-master-detail/price-list-master-detail.component";
import { LoanStatusComponent } from "./pages/sales/loan-status/loan-status.component";
import { SpecialPriceListMasterDetailComponent } from "./pages/sales/special-price-list-master/special-price-list-master-detail/special-price-list-master-detail.component";
import { SpecialPriceListMasterListComponent } from "./pages/sales/special-price-list-master/special-price-list-master-list/special-price-list-master-list.component";
import { ManageFilesComponent } from "./pages/sales/special-price-list-master/manage-files/manage-files.component";
import { WeeklyFocusDashboardListComponent } from "./pages/sales/weekly-focus-dashboard/weekly-focus-dashboard-list/weekly-focus-dashboard-list.component";
import { WeeklyFocusDashboardDetailComponent } from "./pages/sales/weekly-focus-dashboard/weekly-focus-dashboard-detail/weekly-focus-dashboard-detail.component";
import { FactoryStandardEquipmentAndItemsComponent } from "./pages/sales/factory-standard-equipment-and-items/factory-standard-equipment-and-items.component";
import { BuyersOrderReportDynamicComponent } from "./pages/sales-reports/buyers-order-report-dynamic/buyers-order-report-dynamic.component";

// DEBUGGEADORA
import { LaDebuggeadoraComponent } from "./pages/la-debuggeadora/la-debuggeadora.component";
import { AuthGuard } from "./auth/auth.guard";
import { PremiumCareMemberEntitlementComponent } from "./pages/customer-reports/premium-care-member-entitlement/premium-care-member-entitlement.component";
import { CreditMemoComponent } from "./pages/sales/credit-memo/credit-memo.component";
import { EmailBlackListListComponent } from "./pages/sales/email-black-list/email-black-list-list/email-black-list-list.component";
import { EmailBlackListDetailComponent } from "./pages/sales/email-black-list/email-black-list-detail/email-black-list-detail.component";
import { AllInvoicesComponent } from "./pages/sales-reports/all-invoices/all-invoices.component";
import { VehicleStockReportComponent } from "./pages/sales-reports/vehicle-stock-report/vehicle-stock-report.component";
import { WeeklyFocusReportListComponent } from "./pages/sales/weekly-focus-report/weekly-focus-report-list/weekly-focus-report-list.component";
import { WeeklyFocusReportDetailComponent } from "./pages/sales/weekly-focus-report/weekly-focus-report-detail/weekly-focus-report-detail.component";
import { DocumentDownloadComponent } from "./pages/sales-reports/document-download/document-download.component";
import { ChequeIssuedComponent } from "./pages/sales-reports/cheque-issued/cheque-issued.component";
import { CancellationReportComponent } from "./pages/sales-reports/cancellation-report/cancellation-report.component";
import { VehicleStockSummaryReportDetailComponent } from "./pages/sales/vehicle-stock-summary-report/vehicle-stock-summary-report-detail/vehicle-stock-summary-report-detail.component";
import { VehicleStockSummaryReportListComponent } from "./pages/sales/vehicle-stock-summary-report/vehicle-stock-summary-report-list/vehicle-stock-summary-report-list.component";
import { OutstandingDeliveryComponent } from "./pages/sales-reports/outstanding-delivery/outstanding-delivery.component";
import { FinalShortPaymentComponent } from "./pages/sales-reports/final-short-payment/final-short-payment.component";
import { OutstandingCoeBiddingComponent } from "./pages/sales-reports/outstanding-coe-bidding/outstanding-coe-bidding.component";
import { MailingLabelComponent } from "./pages/sales-reports/mailing-label/mailing-label.component";
import { OutstandingCarAllocationComponent } from "./pages/sales-reports/outstanding-car-allocation/outstanding-car-allocation.component";
import { BuyersOrderReportComponent } from "./pages/sales-reports/buyers-order-report/buyers-order-report.component";
import { RegistrationReportComponent } from "./pages/sales-reports/registration-report/registration-report.component";
import { UnpaidInvoicesReportComponent } from "./pages/sales-reports/unpaid-invoices-report/unpaid-invoices-report.component";
import { ProspectReportComponent } from "./pages/sales-reports/prospect-report/prospect-report.component";
import { AccountReceivableAgingReportComponent } from "./pages/autopac-reports/account-receivable-aging-report/account-receivable-aging-report.component";
import { BankPromotionPackageReportComponent } from "./pages/autopac-reports/bank-promotion-package-report/bank-promotion-package-report.component";
import { ChequeIssueMemoComponent } from "./pages/autopac-reports/cheque-issue-memo/cheque-issue-memo.component";
import { BookingBankReportComponent } from "./pages/autopac-reports/booking-bank-report/booking-bank-report.component";
import { CancelledChequesReportComponent } from "./pages/autopac-reports/cancelled-cheques-report/cancelled-cheques-report.component";
import { COESecuredReportComponent } from "./pages/autopac-reports/coe-secured-report/coe-secured-report.component";
import { COEStockByDateReportComponent } from "./pages/autopac-reports/coe-stock-by-date-report/coe-stock-by-date-report.component";
import { COEStockDetailReportComponent } from "./pages/autopac-reports/coe-stock-detail-report/coe-stock-detail-report.component";
import { COEStockSummaryReportComponent } from "./pages/autopac-reports/coe-stock-summary-report/coe-stock-summary-report.component";
import { ContractCancellationReportComponent } from "./pages/autopac-reports/contract-cancellation-report/contract-cancellation-report.component";
import { CreditNoteReportComponent } from "./pages/autopac-reports/credit-note-report/credit-note-report.component";
import { DailyIssueChequeReportComponent } from "./pages/autopac-reports/daily-issue-cheque-report/daily-issue-cheque-report.component";
import { DailyIssueChequeComponent } from "./pages/autopac-reports/daily-issue-cheque/daily-issue-cheque.component";
import { VehicleOverbookReportComponent } from "./pages/sales-reports/vehicle-overbook-report/vehicle-overbook-report.component";

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "top",
  anchorScrolling: "enabled",
  useHash: false,
};

const routes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    component: HomeComponent,
    children: [
      {
        path: "administration/audit-master",
        component: AuditMasterComponent,
      },
      {
        path: "administration/user-management",
        component: UserManagementListComponent,
        pathMatch: "full",
      },
      {
        path: "administration/user-management/:id",
        component: UserManagementDetailComponent,
      },
      {
        path: "administration/user-type-management",
        component: UserTypeManagementListComponent,
        pathMatch: "full",
      },
      {
        path: "administration/user-type-management/:id",
        component: UserTypeManagementDetailComponent,
      },
      {
        path: "administration/user-rights-management",
        component: UserRightsManagementComponent,
        pathMatch: "full",
      },
      {
        path: "administration/kaps-settings",
        component: KapsSettingsComponent,
      },
      {
        path: "administration/sales-team-shuffle",
        component: SalesTeamShuffleComponent,
      },
      {
        path: "customer/customer-search",
        component: CustomerSearchComponent,
      },
      {
        path: "customer/prospect",
        component: ProspectListComponent,
      },
      {
        path: "customer/prospect/:id",
        component: ProspectDetailComponent,
      },
      {
        path: "customer/click-drive-customer",
        component: ClickDriveCustomerComponent,
      },
      {
        path: "customer/click-drive-customer/generate-voucher",
        component: GenerateVoucherComponent,
      },
      {
        path: "customer/click-drive-customer/update-order",
        component: UpdateOrderComponent,
      },
      {
        path: "customer/premium-care-member",
        component: PremiumCareMemberListComponent,
      },
      {
        path: "customer/premium-care-member/:id",
        component: PremiumCareMemberDetailComponent,
      },
      {
        path: "customer-reports/premium-care-member-status",
        component: PremiumCareMemberStatusComponent,
      },
      {
        path: "customer-reports/premium-care-member-entitlement",
        component: PremiumCareMemberEntitlementComponent,
      },
      {
        path: "reservation/manageReservationPriceList",
        component: ReservationPriceListMasterListComponent,
        pathMatch: "full",
      },
      {
        path: "reservation/reservation-dashboard",
        component: ReservationDashboardComponent,
        pathMatch: "full",
      },
      {
        path: "reservation/reservation-price-list-master-detail",
        component: ReservationPriceListMasterDetailComponent,
        pathMatch: "full",
      },
      {
        path: "reservation/reservationRequest",
        component: ReservationComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/accessory/:id",
        component: AccessoryDetailComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/accessory",
        component: AccessoryListComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/booking",
        component: BookingComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/colours-by-model/:id",
        component: ColoursByModelDetailComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/colours-by-model",
        component: ColoursByModelListComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/discount",
        component: DiscountComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/interior-colour",
        component: InteriorColourListComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/interior-colour/:id",
        component: InteriorColourDetailComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/master-colour",
        component: MasterColourListComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/master-colour/:id",
        component: MasterColourDetailComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/model-and-specification/model-and-specification-detail",
        component: ModelAndSpecificationDetailComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/model-and-specification/model-and-specification-list",
        component: ModelAndSpecificationListComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/promotion-free-item/:id",
        component: PromotionDetailComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/promotion-free-item",
        component: PromotionListComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/reinstate-booking",
        component: ReinstateBookingComponent,
        pathMatch: "full",
      },
      {
        path: "vehicle/vehicle-selection",
        component: VehicleSelectionComponent,
        pathMatch: "full",
      },
      {
        path: "sales/control-parameters",
        component: ControlParametersComponent,
      },
      {
        path: "sales/hire-purchase",
        component: HirePurchaseListComponent,
      },
      {
        path: "sales/hire-purchase/:id",
        component: HirePurchaseDetailComponent,
      },
      {
        path: "sales/insurance",
        component: InsuranceListComponent,
      },

      {
        path: "sales/insurance/:id",
        component: InsuranceDetailComponent,
      },
      {
        path: "sales/inventory-vehicle",
        component: InventoryVehicleComponent,
      },
      {
        path: "sales/loan-status-report",
        component: LoanStatusReportComponent,
      },
      {
        path: "sales/price-list-master",
        component: PriceListMasterListComponent,
      },
      {
        path: "sales/price-list-master/:id",
        component: PriceListMasterDetailComponent,
      },
      {
        path: "sales/special-price-list-master",
        component: SpecialPriceListMasterListComponent,
      },
      {
        path: "sales/special-price-list-master/:id",
        component: SpecialPriceListMasterDetailComponent,
      },
      {
        path: "sales/special-price-list-master.manage-files",
        component: ManageFilesComponent,
      },
      {
        path: "sales/shipment-master",
        component: ShipmentMasterComponent,
      },
      {
        path: "sales/price-list-template",
        component: PriceListTemplateListComponent,
      },
      {
        path: "sales/price-list-template/:id",
        component: PriceListTemplateDetailComponent,
      },
      {
        path: "sales/price-list-template-report",
        component: PriceListTemplateReportComponent,
      },
      {
        path: "sales/credit-memo",
        component: CreditMemoComponent,
      },
      {
        path: "sales/loan-status",
        component: LoanStatusComponent,
      },
      {
        path: "sales/email-black-list",
        component: EmailBlackListListComponent,
      },
      {
        path: "sales/email-black-list/:id",
        component: EmailBlackListDetailComponent,
      },
      {
        path: "sales/vehicle-stock-summary-report",
        component: VehicleStockSummaryReportListComponent,
      },
      {
        path: "sales/vehicle-stock-summary-report/:id/:category",
        component: VehicleStockSummaryReportDetailComponent,
      },
      {
        path: "sales/weekly-focus-dashboard",
        component: WeeklyFocusDashboardListComponent,
      },
      {
        path: "sales/weekly-focus-dashboard/:id",
        component: WeeklyFocusDashboardDetailComponent,
      },
      {
        path: "sales/weekly-focus-report",
        component: WeeklyFocusReportListComponent,
      },
      {
        path: "sales/weekly-focus-report/:id",
        component: WeeklyFocusReportDetailComponent,
      },
      {
        path: "sales/factory-standard-equipment-and-items",
        component: FactoryStandardEquipmentAndItemsComponent,
      },
      {
        path: "sales-reports/all-invoices",
        component: AllInvoicesComponent,
      },
      {
        path: "sales-reports/vehicle-stock-report",
        component: VehicleStockReportComponent,
      },
      {
        path: "sales-reports/document-download",
        component: DocumentDownloadComponent,
      },
      {
        path: "sales-reports/cheque-issued",
        component: ChequeIssuedComponent,
      },
      {
        path: "sales-reports/cancellation-report",
        component: CancellationReportComponent,
      },
      {
        path: "sales-reports/outstanding-coe-bidding",
        component: OutstandingCoeBiddingComponent,
      },
      {
        path: "sales-reports/mailing-label",
        component: MailingLabelComponent,
      },
      {
        path: "sales-reports/outstanding-car-allocation",
        component: OutstandingCarAllocationComponent,
      },
      {
        path: "sales-reports/buyers-order-report",
        component: BuyersOrderReportComponent,
      },
      {
        path: "sales-reports/buyers-order-report-dynamic",
        component: BuyersOrderReportDynamicComponent,
      },
      {
        path: "sales-reports/registration-report",
        component: RegistrationReportComponent,
      },
      {
        path: "sales-reports/prospect-report",
        component: ProspectReportComponent,
      },
      {
        path: "sales-reports/unpaid-invoices-report",
        component: UnpaidInvoicesReportComponent,
      },
      {
        path: "sales-reports/vehicle-overbook-report",
        component: VehicleOverbookReportComponent,
      },
      {
        path: "vehicle/vehicle-stock-availability",
        component: VehicleStockAvailabilityComponent,
      },
      {
        path: "autopac/account-adjustment",
        component: AccountAdjustmentComponent,
      },
      {
        path: "autopac/account-code-creation",
        component: AccountCodeCreationComponent,
      },
      {
        path: "autopac/amend-cheque-purpose",
        component: AmendChequePurposeComponent,
      },
      {
        path: "autopac/car-allocation",
        component: CarAllocationComponent,
      },
      {
        path: "autopac/car-registration",
        component: CarRegistrationComponent,
      },
      {
        path: "autopac/cards-deposit-listing",
        component: CardsDepositListingComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/cash-deposit-listing",
        component: CashDepositListingComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/cheque-deposit-listing",
        component: ChequeDepositListingComponent,
      },
      {
        path: "autopac/cheque-enquiry",
        component: ChequeEnquiryComponent,
      },
      {
        path: "autopac/cheque-issue",
        component: ChequeIssueComponent,
      },
      {
        path: "autopac/coe-allocation",
        component: CoeAllocationComponent,
      },
      {
        path: "autopac/coe-bid-staff",
        component: CoeBidStaffComponent,
      },
      {
        path: "autopac/coe-bidding-preparation",
        component: CoeBiddingPreparationComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/coe-bidding-results",
        component: CoeBiddingResultsComponent,
      },
      {
        path: "autopac/contract-management",
        component: ContractManagementComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/customer-enquiry",
        component: CustomerEnquiryComponent,
      },
      {
        path: "autopac/duty-pullout",
        component: DutyPulloutComponent,
      },
      {
        path: "autopac/duty-pullout-taxi",
        component: DutyPulloutTaxiComponent,
      },
      {
        path: "autopac/export-hmc",
        component: ExportToHMCComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/export-hmc-new",
        component: ExportToHmcNewComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/finance-vehicle-receipt",
        component: FinanceVehicleReceiptComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/general-enquiry",
        component: GeneralEnquiryComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/gst-calculation",
        component: GstCalculationComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/invoice",
        component: InvoiceComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/monthly-commission",
        component: MonthlyCommissionComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/open-category-coe-depository",
        component: OpenCategoryCoeDepositoryComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/parf-transfer-date",
        component: ParfTransferDateComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/payment-status-read-only",
        component: PaymentStatusReadOnlyComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/taxi-registration",
        component: TaxiRegistrationComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/update-vehicle-rate",
        component: UpdateVehicleRateComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/eta-date-updation",
        component: EtaDateUpdationComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/open-category-coe-transfer",
        component: OpenCategoryCoeTransferComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/location-master",
        component: LocationMasterListComponent,
      },
      {
        path: "autopac/location-master/:id",
        component: LocationMasterDetailComponent,
      },
      {
        path: "autopac/giro-payment",
        component: GiroPaymentComponent,
      },
      {
        path: "autopac/paymemt-list",
        component: PaymentListComponent,
      },
      {
        path: "autopac/payment-status",
        component: PaymentStatusComponent,
      },
      {
        path: "autopac/fob-invoice-price",
        component: FobInvoicePriceComponent,
      },
      {
        path: "autopac/salesman-receipt",
        component: SalesmanReceiptComponent,
      },
      {
        path: "autopac/service-enquiry",
        component: ServiceEnquiryComponent,
      },
      {
        path: "autopac-reports/accessory-report",
        component: AccessoryReportComponent,
        pathMatch: "full",
      },
      {
        path: "autopac-reports/coe-bids-details-by-date",
        component: COEBidsDetailsByDateReportComponent,
        pathMatch: "full",
      },
      {
        path: "autopac-reports/account-receivable-aging-report",
        component: AccountReceivableAgingReportComponent,
        pathMatch: "full",
      },
      {
        path: "autopac-reports/bank-promotion-package-report",
        component: BankPromotionPackageReportComponent,
        pathMatch: "full",
      },
      {
        path: "autopac-reports/coe-bids-detail",
        component: COEBidsDetailsReportComponent,
        pathMatch: "full",
      },
      {
        path: "autopac/stock-hold-release",
        component: StockHoldReleaseComponent,
      },
      {
        path: "autopac/receipt",
        component: ReceiptComponent,
        pathMatch: "full",
      },
      {
        path: "la-debuggeadora",
        component: LaDebuggeadoraComponent,
        pathMatch: "full",
      },
      {
        path: "sales-reports/outstanding-delivery",
        component: OutstandingDeliveryComponent,
      },
      {
        path: "sales-reports/final-short-payment",
        component: FinalShortPaymentComponent,
      },
      {
        path: "autopac-reports/cheque-issue-memo",
        component: ChequeIssueMemoComponent,
      },
      {
        path: "autopac-reports/booking-bank-report",
        component: BookingBankReportComponent,
      },
      {
        path: "autopac-reports/cancelled-cheques-report",
        component: CancelledChequesReportComponent,
      },
      {
        path: "autopac-reports/coe-secured-report",
        component: COESecuredReportComponent,
      },
      {
        path: "autopac-reports/coe-stock-by-date-report",
        component: COEStockByDateReportComponent,
      },
      {
        path: "autopac-reports/coe-stock-detail-report",
        component: COEStockDetailReportComponent,
      },
      {
        path: "autopac-reports/coe-stock-summary-report",
        component: COEStockSummaryReportComponent,
      },
      {
        path: "autopac-reports/contract-cancellation-report",
        component: ContractCancellationReportComponent,
      },
      {
        path: "autopac-reports/credit-note-report",
        component: CreditNoteReportComponent,
      },
      {
        path: "autopac-reports/daily-issue-cheque-report",
        component: DailyIssueChequeReportComponent,
      },
      {
        path: "autopac-reports/daily-issue-cheque",
        component: DailyIssueChequeComponent,
      },
    ],
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
